<script setup>
import { useTemplateRef } from 'vue';
import { isEmpty } from 'lodash';
import { marcarTodos } from '@/libs/checkboxes';
import InputCheckboxBoolean from '../cifra/InputCheckboxBoolean.vue';

const props = defineProps({
  inputName: { type: String, default: null },
  grupos: { type: Array, required: true },
  titulo: { type: String, default: null },
});

const tabla = useTemplateRef('tabla');

function seleccionarTodo() {
  if (isEmpty(props.grupos)) return;

  marcarTodos(tabla.value);
}
</script>

<template>
  <table v-if="!isEmpty(grupos)" ref="tabla" class="table table-bordered">
    <thead v-if="titulo">
      <tr>
        <th class="col-min">
          <button
            type="button"
            class="btn btn-default btn-xs"
            @click="seleccionarTodo"
          >
            <i class="fa fa-check-square"></i>
          </button>
        </th>
        <th>{{ titulo }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="grupo in grupos" :key="grupo.id">
        <td class="col-min text-center">
          <InputCheckboxBoolean
            :input-id="`check-${grupo.id}`"
            :value="grupo.id"
            :name="inputName"
            class="m-r-none"
          />
        </td>
        <td>
          <label :for="`check-${grupo.id}`" class="clickable">
            {{ grupo.etiqueta || grupo.nombre }}
          </label>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss" scoped>
.m-r-none {
  margin-right: 0 !important;
}
</style>
